import React, { useEffect, useState } from "react";
import "../Styles/MyOrder.css";
import { FaAngleLeft } from "react-icons/fa6";
import { SlHome } from "react-icons/sl";
import { useLocation, useNavigate } from "react-router";
import { Link } from "react-router-dom";
import { cancelOrder, getOrder } from "../Services/Operations/ProductAPI";
import { useSelector } from "react-redux";
import moment from "moment";

const MyOrders = () => {
  const navigate = useNavigate();
  const [orders, setOrder] = useState([]);
  const [showCancelPopup, setShowCancelPopup] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const token = useSelector((state) => state.user.token);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const formData = new FormData();
        formData.append("token", token);

        for (let pair of formData.entries()) {
          console.log(`${pair[0]}: ${pair[1]}`);
        }

        const response = await getOrder(formData);
        if (response && response.data) {
          console.log("Order Data:", response.data);
          setOrder(response.data);
        }
      } catch (error) {
        console.error("Error fetching profile or pages:", error);
      }
    };

    fetchProfile();
  }, [token]);

  const handleCancelClick = (order) => {
    console.log("order : ",order);
    setSelectedOrder(order);
    setShowCancelPopup(true);
  };

  const handleClosePopup = () => {
    setShowCancelPopup(false);
    setSelectedOrder(null);
  };

  const handleCancelOrder = async(order) => {
    try {
        console.log("order : ",order);
        const formData = new FormData();
        formData.append("token", token);
        formData.append("order_id", selectedOrder.id);

        for (let pair of formData.entries()) {
          console.log(`${pair[0]}: ${pair[1]}`);
        }

        const response = await cancelOrder(formData);
        if (response) {
          console.log("cancel response :", response);
        }
      } catch (error) {
        console.error("Error fetching for cancel order:", error);
      }
    setShowCancelPopup(false);
  };

  return (
    <div>
      <div className="my-orders">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            maxWidth: "770px",
            margin: "auto",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <FaAngleLeft onClick={() => navigate(-1)} />
            <p style={{ marginLeft: "23px" }}>My Orders</p>
          </div>
          <div style={{ display: "flex", gap: "20px", marginRight: "13px" }}>
            <Link to="/">
              <SlHome />
            </Link>
          </div>
        </div>
        {orders.map((order) => (
          <div className="order-card" key={order.unique_order_id}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <span
                className="status-canceled"
                style={{ color: "#767373", border: "1px solid #767373" }}
              >
                Order Placed
              </span>
              <div
                className="status-canceled"
                style={{
                  color: "green",
                  border: "1px solid green",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "5px",
                }}
              >
                <span onClick={()=>navigate("/success-page")}>Track Order</span>
                <div
                  style={{
                    width: "13px",
                    height: "13px",
                    backgroundColor: "green",
                    borderRadius: "50%",
                  }}
                ></div>
              </div>
            </div>
            <div className="order-header">
              <h3>{order.unique_order_id}</h3>
              <span className="order-time">
                {moment(order.updated_at).fromNow()}
              </span>
            </div>
            <div className="restaurant-name">
              <h4>{order.restaurant.name}</h4>
            </div>
            <div className="order-items">
              {order.orderitems.map((item) => (
                <div className="item" key={item.id}>
                  <span>x{item.quantity}</span> {item.name}
                  <span className="price">₹{item.price}</span>
                </div>
              ))}
            </div>

            <div className="order-summary">
              <div className="summary-row">
                <span>Delivery Charges</span>
                <span>₹{order.actual_delivery_charge}</span>
              </div>
              <div className="summary-row total">
                <span>Total</span>
                <span>₹{order.total}</span>
              </div>
              <div className="summary-row">
                <span>Payment Mode</span>
                <span>{order.payment_mode}</span>
              </div>
              <div className="location">
                <span>{order.address}</span>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "end",
                justifyContent: "end",
              }}
            >
              <p
                className="status-canceled"
                style={{
                  color: "red",
                  border: "1px solid red",
                  cursor: "pointer",
                }}
                onClick={() => handleCancelClick(order)}
              >
                Cancel Order
              </p>
            </div>
          </div>
        ))}
      </div>
      {showCancelPopup && selectedOrder && (
        <div className="cancel-order-container">
          <div className="cancel-order-box">
            <button className="close-button" onClick={handleClosePopup}>
              ✖
            </button>
            <div className="order-info">
              <span className="info-icon">i</span>
              <p className="order-id">{selectedOrder.unique_order_id}</p>
            </div>
            <p className="cancel-message">Do you want to cancel this order?</p>
            <div className="action-buttons">
              <button className="cancel-button" onClick={handleCancelOrder}>
                Yes, Cancel Order
              </button>
              <button className="go-back-button" onClick={handleClosePopup}>
                Go back
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MyOrders;
